import { env_config } from '@/config';
import cookies from '@/utils/cookie';
import * as storage from '@/utils/storage';
import Utils from '@/utils/utils';

export function relateMessage() {
  // 暂时只在微信环境做h5绑定
  // 小程序webview不处理，因为域名需要配置到后台
  if(Utils.isWeAppEnv() || !Utils.browser().wechat) return;

  const cookieValue = cookies.get() || {};
  if(!cookieValue.officialAccountsId || cookieValue.userType !== 'REGULAR' || [999, 998, 997].includes(+cookieValue.officialAccountsId)) return;

  // 作为客户机，x小时内只需向iframe提一次请求
  const timestamp = storage.get('relate_timestamp_Rme9HRdd') || 0;
  const needRelate = Date.now() - timestamp > 2 * 60 * 60 * 1000;
  if(!needRelate) return;

  const iframe = document.createElement('iframe');
  const src = env_config.PRODUCT_DOMAIN + '/statichtml/relate';
  iframe.setAttribute('src', src);
  iframe.style.display = 'none';
  iframe.onload = function() {
    // 发送消息
    iframe.contentWindow.postMessage({
      type: 'cookie_info',
      msg: cookieValue
    }, '*');
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 30 * 1000);

    storage.put('relate_timestamp_Rme9HRdd', Date.now());
  };

  document.body.appendChild(iframe);
}